// Serviciu client pentru notificări in-app (clopoțel + necitite) — FAZA 2
import { apiGet, apiPost } from './api';
import type { AppNotification, HalCollection } from '@/types';

// Opțiuni pentru listarea notificărilor
export interface GetNotificationsOptions {
  limit?: number;
  onlyUnread?: boolean;
}

// Obținere listă notificări (implicit toate, opțional doar necitite)
export async function getNotifications(
  opts: GetNotificationsOptions = {}
): Promise<AppNotification[]> {
  const params: Record<string, unknown> = {};
  if (opts.limit !== undefined) {
    params.limit = opts.limit;
  }
  if (opts.onlyUnread) {
    params.onlyUnread = true;
  }
  const response = await apiGet<{ notifications: AppNotification[] }>(
    '/auth/data/notifications',
    { params }
  );
  return response.notifications || [];
}

// Obținere număr notificări necitite (pentru badge-ul clopoțelului)
export async function getUnreadCount(): Promise<number> {
  const response = await apiGet<{ count: number }>(
    '/auth/data/notifications/unread-count'
  );
  return response.count || 0;
}

// Marcare notificare ca citită
export async function markRead(id: number): Promise<void> {
  await apiPost(`/auth/data/notifications/${id}/read`, {});
}

// Marcare toate notificările ca citite
export async function markAllRead(): Promise<void> {
  await apiPost('/auth/data/notifications/read-all', {});
}
